import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=ad0e679e&scoped=true"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"
import style0 from "./Patients.vue?vue&type=style&index=0&id=ad0e679e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0e679e",
  null
  
)

export default component.exports